<script>
export default {
  props: {
    projectItem: {
      default: () => {
        return {}
      },
      type: Object
    }
  }
}
</script>
<template>
  <!-- 单个item -->
  <div class="related_project_item_container">
    <div class="top_container">
      <!-- <div class="img_mark_container"> -->
      <span>{{ projectItem.stage }}</span>
      <div class="icon_container">
        <img
          v-if="projectItem.videoNum > 0"
          class="icon_video"
          src="../images/icon-video.png"
        />
        <img
          v-if="projectItem.vrUrl"
          class="icon_vr"
          src="../images/icon-vr.png"
        />
      </div>
      <!-- </div> -->
      <img :src="projectItem.projectImgOssUrl" class="project_image" />
    </div>
    <h4 class="project_title gs_one_line">{{ projectItem.projectName }}</h4>
    <ul>
      <li v-if="projectItem.houseType">{{ projectItem.houseType }}</li>
      <li v-if="projectItem.style">{{ projectItem.style }}</li>
      <li v-if="projectItem.decorationBudget">
        {{ projectItem.decorationBudget }}万
      </li>
    </ul>
  </div>
</template>
<style lang="scss">
.gs_one_line {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.related_project_item_container {
  width: 100%;
  border-radius: 5px;
  * {
    margin: 0;
    padding: 0;
  }

  .img_mark_container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  display: flex;
  flex-direction: column;
  // border: 1px solid red;

  .project_title {
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 18px;
    padding-top: 15px;
    padding-bottom: 10px;
  }

  .top_container {
    position: relative;

    .icon_container {
      bottom: 15px;
      display: flex;
      position: absolute;
      margin-left: 5px;

      %icon_common {
        width: 30px;
        height: 30px;
        margin-left: 10px;
      }
      .icon_video {
        @extend %icon_common;
        left: 15px;
      }

      .icon_vr {
        @extend %icon_common;
        left: 55px;
      }
    }

    span {
      position: absolute;
      display: inline-block;
      font-size: 16px;
      color: rgba(42, 42, 42, 1);
      line-height: 16px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 2px;
      top: 15px;
      left: 15px;
      padding: 4px 10px;
    }

    .project_image {
      width: 100%;
      border-radius: 5px;
    }
  }

  ul {
    li {
      display: inline;
      list-style: none;
      font-size: 16px;
      font-weight: 400;
      color: rgba(68, 68, 68, 1);
      line-height: 16px;
    }
  }
}

@media screen and (max-width: 940px) {
  .project_title {
    padding-top: 13px !important;
    padding-bottom: 5px !important;
  }
  .related_project_item_container {
    .top_container {
      .icon_container {
        .icon_video {
          width: 17px !important;
          height: 17px !important;
          margin-left: 5px !important;
        }
        .icon_vr {
          width: 17px !important;
          height: 17px !important;
          margin-left: 5px !important;
        }
      }
      span {
        width: 36px !important;
        height: 16px !important;
        text-align: center !important;
        line-height: 18px !important;
        font-size: 12px !important;
        padding: 0px !important;
        top: 10px !important;
        left: 10px !important;
      }
    }
  }
}
</style>
